import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { useCurrentPage } from '»utils/customHooks';
import { TrlNumberFormatted } from '»utils/number';
import { trlFieldDefaultValue } from '»utils/trlFieldDefaultValue';

import {
  ContainerLeftStyled,
  LabelHeaderStyled,
  LabelStyled,
  LabelValueStyled,
} from './PrimarySimulationCharges.styles';
import {
  BoxChargesStyled,
  BoxOrderContainerStyled,
  BoxOrderStyled,
} from './PrimarySimulationChargesOrder.styles';

export const PrimarySimulationChargesOrder = ({
  order,
  orderComissions,
  dataItem: { trancheType, subscriptionPrice },
  ...rest
}) => {
  const {
    values: { inputQuantity, inputPrice },
    final,
  } = rest;

  const { isFundsListPage } = useCurrentPage();

  let ordBookKey;
  if (order) {
    [{ ordBookKey }] = order;
  }

  const [{ grossAmount, comission, netAmount, cashAccountCurrency }] =
    orderComissions;

  return (
    <Box id="divCommissions">
      <BoxOrderContainerStyled>
        <BoxOrderStyled>
          <LabelHeaderStyled>
            <FormattedMessage id="TRLT_UI-ORDER" />
          </LabelHeaderStyled>
          <ContainerLeftStyled>
            {final && (
              <>
                <LabelStyled>
                  <FormattedMessage id="TRLT_UI-ORDER_ID" />
                </LabelStyled>
                <LabelValueStyled>{ordBookKey}</LabelValueStyled>
              </>
            )}
            <LabelStyled>
              <FormattedMessage id="TRLT_UI-QTY_ORDERED" />
            </LabelStyled>
            <LabelValueStyled>
              <TrlNumberFormatted
                value={
                  trancheType === 'R' ? trlFieldDefaultValue() : inputQuantity
                }
              />
            </LabelValueStyled>
            <LabelStyled>
              <FormattedMessage id="TRLT_UI-ASK_PRICE" />
            </LabelStyled>
            <LabelValueStyled>
              <TrlNumberFormatted
                value={
                  isFundsListPage
                    ? subscriptionPrice
                    : trancheType !== 'R'
                      ? inputPrice
                      : null
                }
                decimalDigits={2}
              />
            </LabelValueStyled>
            <LabelStyled>
              <FormattedMessage id="TRLT_UI-ORDER_VALUE" />
            </LabelStyled>
            <LabelValueStyled>
              <TrlNumberFormatted
                value={trancheType === 'R' ? inputQuantity : grossAmount}
                decimalDigits={2}
              />
            </LabelValueStyled>
          </ContainerLeftStyled>
        </BoxOrderStyled>
        <BoxChargesStyled>
          <LabelHeaderStyled />
          <ContainerLeftStyled>
            <LabelStyled>
              <FormattedMessage id="TRLT_UI-ORDER_CHARGES" />
            </LabelStyled>
            <LabelValueStyled>
              <TrlNumberFormatted value={comission} />
            </LabelValueStyled>
            <LabelStyled>
              <FormattedMessage id="TRLT_UI-NET_VALUE" />
            </LabelStyled>
            <LabelValueStyled>
              <TrlNumberFormatted value={netAmount} />
            </LabelValueStyled>
            <LabelStyled>
              <FormattedMessage id="TRLT_UI-CURRENCY" />
            </LabelStyled>
            <LabelValueStyled>{cashAccountCurrency}</LabelValueStyled>
          </ContainerLeftStyled>
        </BoxChargesStyled>
      </BoxOrderContainerStyled>
    </Box>
  );
};

PrimarySimulationChargesOrder.propTypes = {
  order: PropTypes.array,
  orderComissions: PropTypes.array,
  dataItem: PropTypes.object,
};
